import { Injectable } from '@angular/core';
import moment from 'moment';
import { HockeyCategory } from '../model/competitions/HockeyCategory';
import { Competition } from '../model/competitions/Competition';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor() { }

  static getCutoffDateForCategory(category: HockeyCategory, competition: Competition): string {
    // Para competencias de hockey con fechas específicas por categoría
    if (competition.customData?.isHockeyCompetition &&
        competition.customData?.categoryCutoffDates &&
        competition.customData.categoryCutoffDates[category.id]) {
      return competition.customData.categoryCutoffDates[category.id];
    }

    // Fallback a la fecha global para modalidades que no son hockey o cuando no hay fecha específica
    return competition.baseDateToCalculateAge;
  }

  static calculateMinBornDate(category: HockeyCategory, competition: Competition): { minDate: string, maxDate: string } {
    const minAge = category.minYearsOld;
    const maxAge = category.maxYearsOld;

    // Usar la fecha de corte específica para la categoría (hockey) o la fecha global
    const cutoffDate = this.getCutoffDateForCategory(category, competition);

    // Fecha de inicio del torneo para evaluar edad mínima
    const startDate = competition.startDate;

    // Para edad MÁXIMA: usar fecha de corte (no debe superar maxAge al final)
    const minDate = moment(cutoffDate)
      .subtract(maxAge, 'years')
      .subtract(1, 'year')
      .format('YYYY-MM-DD');

    // Para edad MÍNIMA: usar fecha de INICIO del torneo (debe tener minAge al comenzar)
    const maxDate = moment(startDate)
      .subtract(minAge, 'years')
      .format('YYYY-MM-DD');

    return { minDate, maxDate };
  }

  /**
   * Verifica si un miembro tiene un error de categoría por haber sido inscrito
   * con la lógica antigua (solo fecha de corte, sin validar edad al inicio)
   */
  static hasCategoryAgeError(birthDay: string, category: HockeyCategory, competition: Competition): boolean {
    const minAge = category.minYearsOld;
    const startDate = competition.startDate;

    // Calcular edad al inicio del torneo
    const ageAtStart = moment(startDate).diff(birthDay, 'years');

    // Tiene error si NO cumple la edad mínima al inicio del torneo
    return ageAtStart < minAge;
  }
}
